import { render, staticRenderFns } from "./IframeV4Layout.vue?vue&type=template&id=2da30e6d&scoped=true&"
import script from "./IframeV4Layout.vue?vue&type=script&lang=js&"
export * from "./IframeV4Layout.vue?vue&type=script&lang=js&"
import style0 from "./IframeV4Layout.vue?vue&type=style&index=0&id=2da30e6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da30e6d",
  null
  
)

export default component.exports